import { useState } from "react"
import { classNames, OnChangeEvent, OnClickEvent } from "../Components"
import { Icon, Icons } from "../Components/Icon"

interface DetailsToggleProps {
  className?: string;
  onChange?: OnChangeEvent<boolean>;
  onDisable?: OnClickEvent;
  onEnable?: OnClickEvent;
}

export const DetailsToggleData = {
  nextDetails(details: boolean): boolean {
    return !details;
  },
  // which lifecycle callbacks fire when toggling from the given current state
  callbacksToFire(details: boolean): { enable: boolean; disable: boolean } {
    return { enable: !details, disable: details };
  },
};

export function DetailsToggle({ className, onChange, onDisable, onEnable }: DetailsToggleProps) {
  const [details, setDetails] = useState<boolean>(false);

  function toggleDetails() {
    const next = DetailsToggleData.nextDetails(details);
    const { enable, disable } = DetailsToggleData.callbacksToFire(details);
    if (onEnable && enable) {
      onEnable();
    }
    if (onDisable && disable) {
      onDisable();
    }
    if (onChange) {
      onChange(next);
    }
    setDetails(next);
  }

  return (
    <div className={classNames(["DetailsToggle", className])}>
      <Icon className="button" icon={details ? Icons.ArrowUp : Icons.ArrowDown} onClick={toggleDetails} />
    </div>
  );
}
